const initialCouponBannerState = {
  coupon: '',
  isValid: false
};

export const couponBannerReducerKey = 'couponBanner';
export const couponBannerReducer = (state = initialCouponBannerState, action) => {
  switch (action.type) {
    case 'SET_COUPON':
      return {
        ...state,
        coupon: action.payload.coupon,
        isValid: action.payload.isValid
      };
    default:
      return state;
  }
};
